<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link to="/users/entite/create/null" v-if="can('user-create')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12">
          <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
                  <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
                <strong v-if="!response.errors">{{response.message}}</strong>
              </b-alert>
              <b-alert v-if="!response.errors" :show="dismissCountDown"
                        dismissible
                        :variant="response.success== true ? 'success':'danger'"
                        @dismissed="dismissCountdown=0"
                        @dismiss-count-down="countDownChanged">
                <strong v-if="!response.errors">{{response.message}}</strong>
              </b-alert>
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              
              <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="rows" :row-style-class="rowStyleClassFn" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                                <router-link :to="'edit/' + props.row.id" v-if="can('user-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                
                                <span v-if="props.formattedRow['active']=='activé'"><b-dropdown-item-button aria-describedby="header1" v-if="can('user-delete')" @click.prevent="confirm(props.row.id)"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button></span>
                                <span v-if="props.formattedRow['active']=='désactivé'"><b-dropdown-item-button aria-describedby="header1" v-if="can('user-delete')" @click.prevent="confirmA(props.row.id)"><i class="fa fa-trash"></i> Activer</b-dropdown-item-button></span>
                                <b-dropdown-item-button aria-describedby="header1" v-if="can('user-delete')" @click.prevent="deleteA(props.row.id)"><i class="fa fa-trash"></i> Supprimer</b-dropdown-item-button>
                                <!-- <router-link :to="'show/' + props.row.id" v-if="can('user-list-responsable')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                            </div>  
                            <div role="group" aria-lableledby="header2">
                              <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>   
                                <router-link :to="'/historique/user/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/transferts/list/user/'+ props.row.id" v-if="can('operation-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Opérations</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/plannings/user/list/'+ props.row.id" v-if="can('planning-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-calendar"></i> Plannings</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/approvisionnements/user/list/'+ props.row.id" v-if="can('approvisionnement-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Approvisionnements</b-dropdown-item-button>
                                </router-link>
                              <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                            </div>              
                          </b-dropdown>
                          <b-modal ref="myModalRef" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir désactiver cet utilisateur ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_delete" style="max-width: 100%;">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click.prevent="desactiver()" style="max-width: 100%;">Désactiver</b-btn>
                          </b-modal>
                          <b-modal ref="myModalRefA" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir activer cet utilisateur ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_deleteA" style="max-width: 100%;">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click.prevent="activer()" style="max-width: 100%;">Activer</b-btn>
                          </b-modal>
                          <b-modal ref="myModalRefS" hide-footer centered title="Confirmation de la désativation">
                            <div class="d-block text-center">
                              <p style>Etes vous certain de vouloir supprimer cet utilisateur ?</p>
                              <h5>Voulez-vous continuer ?</h5>
                            </div>
                            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_deleteS" style="max-width: 100%;">Annuler</b-btn>
                            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click.prevent="supprimer()" style="max-width: 100%;">Supprimer</b-btn>
                          </b-modal>
                    </span>
                    <span style="font-size: 0.875rem;" v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>    
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      user_id:'',
      totalRecords :0,
      columns: [
        {
          label: 'Nom',
          field: 'name',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Email',
          field: 'email',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Entité',
          field: 'entite_nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Agence',
          field: 'agence_nom',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Ville',
          field: 'agence_ville',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Roles',
          field: 'role_name',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Statut',
          field: 'active',
         // type: 'percentage',
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Crée le',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      serverParams: {
        name:'',
        email:'',
        entite_nom:'',
        agence_nom:'',
        agence_ville:'',
        role_name:'',
        created_at:'',
        page:1,
        current_page: 1,
        nb_lines:10
      }
    };
  },
  methods:{
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    rowStyleClassFn(row) {
      return row.active === 'désactivé' ? 'desactive' : '';
    },
    formatFn: function (value) {
        return value != null ? value : null
    },
    hideModal () {
      this.$refs.myModalRef.hide()
      },
      hideModalA () {
      this.$refs.myModalRefA.hide()
      },
      hideModalS () {
      this.$refs.myModalRefS.hide()
      },
      async cancel_delete(){
        this.hideModal()
      },
      async cancel_deleteA(){
        this.hideModalA()
      },
      async cancel_deleteS(){
        this.hideModalS()
      },
      async confirm(id){
          this.user_id = id
          this.$refs.myModalRef.show()
      },
      async confirmA(id){
          this.user_id = id
          this.$refs.myModalRefA.show()
      },
      async deleteA(id){
          this.user_id = id
          this.$refs.myModalRefS.show()
      },
      async desactiver(){
        //console.log(this.entity_id)
        this.hideModal()
        this.response = await this.$store.dispatch('user/desactive_users',this.user_id)
        this.showAlert()
        this.loadItems()
    },
    async activer(){
        //console.log(this.entity_id)
        this.hideModalA()
        this.response = await this.$store.dispatch('user/active_users',this.user_id)
        this.showAlert()
        this.loadItems()
    },
    async supprimer(){
        //console.log(this.entity_id)
        this.hideModalS()
        this.response = await this.$store.dispatch('user/delete_users',this.user_id)
        this.showAlert()
        this.loadItems()
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async get_all_users(){
        this.$store.dispatch('user/get_all_users').then(()=>{
          return this.rows =  store.getters['user/rows'];
        })
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.updateParams({page: params.currentPage,current_page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.serverParams.nb_lines = params.currentPerPage
      console.log(params)
      this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
      });
      this.loadItems();
    },    
    onColumnFilter(params) {
      this.serverParams.name=params.columnFilters.name,
      this.serverParams.email=params.columnFilters.email,
      this.serverParams.entite_nom=params.columnFilters.entite_nom,
      this.serverParams.agence_nom=params.columnFilters.agence_nom,
      this.serverParams.agence_ville=params.columnFilters.agence_ville,
      this.serverParams.role_name=params.columnFilters.role_name,
      this.serverParams.created_at=params.columnFilters.created_at,
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.$store.dispatch('user/get_all_users',this.serverParams).then((response)=>{
          this.totalRecords = response.total;
          return this.rows =  store.getters['user/rows'];
      })
    }
  },
  mounted(){
    // this.get_all_users()
    this.loadItems()
  }
  
}
</script>
